import React, { Fragment } from 'react';
import { Button, Form, Grid, Header, Icon, Loader, Popup, Table } from 'semantic-ui-react';
import SimpleTwoColumnTableRow from './SimpleTwoColumnTableRow';
import { FormattedMessage } from 'react-intl';
import axios from 'axios';
import { Link, Redirect } from 'react-router-dom';
import moment from 'moment';
import { toast } from 'react-toastify';
import { DateTimePicker } from 'react-widgets';
import { getLookupName } from './util';


// currentStudyProgramInfo
export default class CurrentStudyTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentYear: '',
            showEditForm: false,
            showEditDebitForm: false,
            showEditTitleGenderForm: false,
            showEditDroppedOutDateForm: false,
            showStudyProgramForm: false,
            studyPrograms: [],
            selectedStudyProgram: null,
        };
        this.saveComment = this.saveComment.bind(this);
        this.saveDebit = this.saveDebit.bind(this);
        this.saveTitleGender = this.saveTitleGender.bind(this);
        this.saveDroppedOutDate = this.saveDroppedOutDate.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getSPImplementations = this.getSPImplementations.bind(this);
    }
    componentDidMount() {
        axios.get('/genders')
            .then(res => {
                let genders = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                })).filter(e => e.name !== 'nepoznato');
                this.setState({
                    genders
                });
            });

        if (
            this.props.currentStudyProgramInfo &&
            this.props.currentStudyProgramInfo.studyProgramBasicId
        ) {
            this.getSPImplementations();
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.currentStudyProgramInfo !== this.props.currentStudyProgramInfo &&
            this.props.currentStudyProgramInfo.studyProgramBasicId
        ) {
            this.getSPImplementations();
        }
    }


    UNSAFE_componentWillMount() {
        axios.get('/academic-years/current')
            .then(res => {
                this.setState({ currentYear: res.data.id });
            });
    }

    saveComment() {
        let obj = {
            sspComment: this.state.comment,
        };
        axios.put(`students/edit-ssp-comment/${this.props.studentId}/${this.props.studyProgramId}`, { ...obj })
            .then(res => {
                this.props.getCurrentStudyProgramInfo();
                this.setState({ showEditForm: false });
                toast('Izmjena napomene je uspješno izvršena.');
            })
            .catch(err => {
                console.log('Failed to edit comment.');
                toast('Došlo je do greške! Izmjena napomene nije izvršena.');
            });
    }

    saveDebit() {
        let obj = {
            sspDebit: this.state.debit,
        };
        axios.put(`students/edit-ssp-debit/${this.props.studentId}/${this.props.studyProgramId}`, { ...obj })
            .then(res => {
                this.props.getCurrentStudyProgramInfo();
                this.setState({ showEditDebitForm: false });
                toast('Izmjena dugovanja je uspješno izvršena.');
            })
            .catch(err => {
                console.log('Failed to edit comment.');
                toast('Došlo je do greške! Izmjena dugovanja nije izvršena.');
            });
    }


    saveTitleGender() {
        axios.put(`students/edit-gender-for-title/${this.props.studentId}/${this.props.studyProgramId}/${this.state.titleGender}`)
            .then(res => {
                this.props.getCurrentStudyProgramInfo();

                toast('Izmjena za rod za titulu je uspješno izvršena.');
            })
            .finally(() => {
                this.setState({ showEditTitleGenderForm: false });
            })
            .catch(err => {
                console.log('Failed to edit comment.');
                toast('Došlo je do greške! Izmjena za rod za titulu nije izvršena.');
            });
    }

    saveDroppedOutDate() {
        axios.put(`students/edit-dropped-out-date/${this.props.studentId}/${this.props.studyProgramId}`, { droppedOutDate: this.state.droppedOutDate })
            .then(res => {
                this.props.getCurrentStudyProgramInfo();
                this.props.updateStudentStatuses();
                toast('Izmjena datuma ispisivanja je uspješno izvršena.');
            })
            .finally(() => {
                this.setState({ showEditDroppedOutDateForm: false });
            })
            .catch(err => {
                console.log('Failed to edit dropped out date.');
                toast('Došlo je do greške! Izmjena datuma ispisivanja nije izvršena.');
            });
    }

    saveStudyProgram() {
        axios.put(`students/sp-edit/${JSON.parse(localStorage.getItem('student')).id}/${this.state.selectedStudyProgram}`)
            .then(res => {
                this.props.getCurrentStudyProgramInfo(this.state.selectedStudyProgram);
                toast('Izmjena za studijski program je uspješno izvršena.');
            })
            .finally(() => {
                this.setState({ showStudyProgramForm: false });
            })
            .catch(err => {
                const errorMessage = err.response.data;

                if (errorMessage.includes('Student already has a record for the provided StudyProgram ID')) {
                    toast('Student je već upisan na odabrani studijski program.');
                } else {
                    console.log('Failed to edit sp.');
                    toast('Došlo je do greške! Izmjena za studijski program nije izvršena.');
                }
            });
    }

    handleInputChange(event, { name, value }) {
        if (value === '') {
            this.setState({
                [name]: null
            });
        }
        this.setState({
            [name]: value
        });
    }

    getSPImplementations() {
        axios.get(`study-programs/implementations-for-basic/${this.props.currentStudyProgramInfo.studyProgramBasicId}`)
            .then(res => {
                const studyPrograms = res.data.map((el) => {
                    const sp = el.studyProgram;
                    const spb = sp && sp.studyProgramBasic;

                    return {
                        ...el,
                        key: el.id,
                        value: sp.id,
                        text:
                            (spb && spb.name ? spb.name : '') + ' | ' +
                            (sp && sp.name ? sp.name : '') + ' | ' +
                            (sp && sp.description ? sp.description : '')
                    };
                });

                this.setState({ studyPrograms });
            })
            .catch(err => {
                console.error('Failed to fetch study program implementations:', err);
            });
    }


    render() {
        const localStorageRole = localStorage.getItem('activeRole');
        const isAdmin = localStorageRole === 'AIDA' || localStorageRole === 'Administrator';
        const { currentStudyProgramInfo, faculties, departments } = this.props;
        return (
            this.props.currentStudyProgramInfoLoader ?
                <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                :
                <Table celled size="small" unstackable compact>
                    <Table.Header>
                        <Table.Row>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {!this.props.noIndex && <SimpleTwoColumnTableRow
                            name="Index"
                            keyName="index"
                            value={currentStudyProgramInfo.index}
                        />}
                        <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.faculty" />}
                            keyName="faculties"
                            value={faculties.map(el => (<div>{el.name} <br /></div>))}
                        />
                        { departments.length ? <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.department" />}
                            keyName="department"
                            value={departments.map(el => (<div>{el.name}</div>))}
                        /> : null}
                        <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.studyProgram" />}
                            keyName="studyProgramBasic"
                            value={
                                this.state.showStudyProgramForm ? (
                                    <Form size="mini">
                                        <Form.Group widths="equal">
                                            <Form.Dropdown
                                                placeholder="Izaberite studijski program"
                                                selection
                                                fluid
                                                search
                                                name="selectedStudyProgram"
                                                value={this.state.selectedStudyProgram}
                                                options={this.state.studyPrograms}
                                                onChange={(e, { name, value }) => this.setState({ [name]: value })}
                                            />
                                            <Button
                                                basic
                                                color="blue"
                                                size="mini"
                                                floated="right"
                                                onClick={() => {
                                                    this.saveStudyProgram();
                                                    this.setState({ showStudyProgramForm: false });
                                                }}
                                            >
                                                Sačuvaj
                                            </Button>
                                            <Button
                                                basic
                                                size="mini"
                                                floated="right"
                                                onClick={() => {
                                                    this.setState({ showStudyProgramForm: false });
                                                }}
                                            >
                                                Odustani
                                            </Button>
                                        </Form.Group>
                                    </Form>
                                ) : (
                                    <Fragment>
                                        <Grid columns={3}>
                                            <Grid.Column width={8} verticalAlign="middle">
                                                {currentStudyProgramInfo.studyProgramBasic || currentStudyProgramInfo.studyProgram
                                                    ? currentStudyProgramInfo.studyProgramBasic +
                                                    ((localStorage.getItem('activeRole').substr(0, 8) !== 'Student:' &&
                                                        localStorage.getItem('activeRole').substr(0, 20) !== 'Diplomirani student:' &&
                                                        localStorage.getItem('activeRole').substr(0, 7) !== 'Ispisan')
                                                        ? ' | ' +
                                                        currentStudyProgramInfo.studyProgram +
                                                        (currentStudyProgramInfo.studyProgramDescription
                                                            ? ' | ' + currentStudyProgramInfo.studyProgramDescription
                                                            : '')
                                                        +
                                                        // (currentStudyProgramInfo.studyProgramDescription
                                                        //     ? ' | ' + currentStudyProgramInfo.studyProgramDescription
                                                        //     : '')
                                                        // +
                                                        (currentStudyProgramInfo.studyProgramBasicComment
                                                            ? ' | ' + currentStudyProgramInfo.studyProgramBasicComment
                                                            : '')

                                                        : '')
                                                    : ''}
                                            </Grid.Column>
                                            <Grid.Column width={8} verticalAlign="middle" textAlign="right">
                                                {(localStorage.getItem('activeRole').substr(0, 8) !== 'Student:' &&
                                                    localStorage.getItem('activeRole').substr(0, 20) !== 'Diplomirani student:' &&
                                                    localStorage.getItem('activeRole').substr(0, 7) !== 'Ispisan') ? (
                                                        <Link
                                                            target="blank_"
                                                            onClick={() => {
                                                                localStorage.setItem('studyProgramBasic', currentStudyProgramInfo.studyProgramBasicId);
                                                                localStorage.setItem('id', currentStudyProgramInfo.studyProgramBasicId);
                                                                localStorage.setItem('basicName', currentStudyProgramInfo.studyProgramBasic);
                                                                localStorage.setItem('archived', currentStudyProgramInfo.archived);
                                                                localStorage.setItem('studyProgramBasicName', currentStudyProgramInfo.studyProgramBasic);
                                                                localStorage.setItem('studyProgramDescription', currentStudyProgramInfo.studyProgramDescription);
                                                                localStorage.setItem(
                                                                    'implementation',
                                                                    JSON.stringify({
                                                                        studyProgram: {
                                                                            name: currentStudyProgramInfo.studyProgram,
                                                                            id:
                                                                            JSON.parse(localStorage.getItem('student')).studyProgramId ||
                                                                            currentStudyProgramInfo.studyProgram.id,
                                                                        },
                                                                        studyProgramBasicName: currentStudyProgramInfo.studyProgramBasic,
                                                                    })
                                                                );
                                                            }}
                                                            to={{
                                                                pathname:
                                                                localStorage.getItem('activeRole') === 'AIDA' ||
                                                                localStorage.getItem('activeRole') === 'Administrator'
                                                                    ? '/osnovni-studijski-programi/implementacije/semestri'
                                                                    : '/studijski-programi/implementacije/semestri',
                                                            }}
                                                        >
                                                            <Popup
                                                                size="tiny"
                                                                trigger={
                                                                    <Button
                                                                        basic
                                                                        circular
                                                                        color="blue"
                                                                        icon="external alternate"
                                                                        size="mini"
                                                                    />
                                                                }
                                                                content="Idi na studijski program"
                                                                hideOnScroll
                                                                position="top center"
                                                            />
                                                        </Link>
                                                    ) : null}
                                                {isAdmin && (
                                                    <Popup
                                                        size="tiny"
                                                        trigger={
                                                            <Button
                                                                basic
                                                                circular
                                                                floated="right"
                                                                color="green"
                                                                icon="pencil"
                                                                size="mini"
                                                                onClick={() =>
                                                                    this.setState({
                                                                        selectedStudyProgram: currentStudyProgramInfo.studyProgramId,
                                                                        // JSON.parse(localStorage.getItem('student')).studyProgramId,
                                                                        showStudyProgramForm: true,
                                                                    })
                                                                }
                                                            />
                                                        }
                                                        content="Izmijeni"
                                                        hideOnScroll
                                                        position="top center"
                                                    />
                                                )}
                                            </Grid.Column>
                                        </Grid>
                                    </Fragment>
                                )
                            }
                            // value={
                            //     <Fragment>
                            //         <Grid columns={3}>
                            //             <Grid.Column width={8} verticalAlign="middle" >{currentStudyProgramInfo.studyProgramBasic || currentStudyProgramInfo.studyProgram ? currentStudyProgramInfo.studyProgramBasic +
                            //                     (
                            //                         (localStorage.getItem('activeRole').substr(0, 8) !== 'Student:'
                            //                             && localStorage.getItem('activeRole').substr(0, 20) !== 'Diplomirani student:' && localStorage.getItem('activeRole').substr(0, 7) !== 'Ispisan') ?
                            //                             ' | ' + currentStudyProgramInfo.studyProgram + (currentStudyProgramInfo.studyProgramDescription ? ' | ' + currentStudyProgramInfo.studyProgramDescription : '')
                            //                             : ''
                            //                     ) : ''}</Grid.Column>
                            //             <Grid.Column width={8} verticalAlign="middle" textAlign="right" >
                            //                 {(localStorage.getItem('activeRole').substr(0, 8) !== 'Student:'
                            //                         && localStorage.getItem('activeRole').substr(0, 20) !== 'Diplomirani student:' && localStorage.getItem('activeRole').substr(0, 7) !== 'Ispisan') ? <Link
                            //                         target="blank_"
                            //                         onClick={() => {
                            //                             localStorage.setItem('studyProgramBasic', currentStudyProgramInfo.studyProgramBasicId);
                            //                             localStorage.setItem('id', currentStudyProgramInfo.studyProgramBasicId);
                            //                             localStorage.setItem('basicName', currentStudyProgramInfo.studyProgramBasic);
                            //                             localStorage.setItem('archived', currentStudyProgramInfo.archived);
                            //                             localStorage.setItem('studyProgramBasicName', currentStudyProgramInfo.studyProgramBasic);
                            //                             localStorage.setItem('studyProgramDescription', currentStudyProgramInfo.studyProgramDescription);
                            //                             localStorage.setItem('implementation', JSON.stringify({ studyProgram: { name: currentStudyProgramInfo.studyProgram, id: JSON.parse(localStorage.getItem('student')).studyProgramId ? JSON.parse(localStorage.getItem('student')).studyProgramId : currentStudyProgramInfo.studyProgram.id }, studyProgramBasicName: currentStudyProgramInfo.studyProgramBasic }));
                            //                         }}
                            //                         to={{ pathname: (localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator') ? '/osnovni-studijski-programi/implementacije/semestri' : '/studijski-programi/implementacije/semestri' }}
                            //                     >
                            //                         <Popup
                            //                             size="tiny"
                            //                             trigger={<Button
                            //                                 basic="true"
                            //                                 circular
                            //                                 color="blue"
                            //                                 icon="external alternate"
                            //                                 size="mini"
                            //                             />}
                            //                             content="Idi na studijski program"
                            //                             hideOnScroll
                            //                             position="top center"
                            //                             />
                            //                     </Link> : null}
                            //             </Grid.Column>
                            //         </Grid>
                            //
                            //
                            //     </Fragment>
                            //
                            // }
                        />
                        {/* {localStorage.getItem('activeRole').substr(0, 8) === 'Student:' && <SimpleTwoColumnTableRow */}
                        {/*    name={<FormattedMessage id="common.semester" />} */}
                        {/*    keyName="currentSemester" */}
                        {/*    value={currentStudyProgramInfo.gradStudentAcademicYear ? currentStudyProgramInfo.gradStudentAcademicYear.id === this.state.currentYear ? 'Apsolventski staž' : currentStudyProgramInfo.currentSemester : currentStudyProgramInfo.currentSemester} */}
                        {/* />} */}
                        <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.studyCycle" />}
                            keyName="studyCycle"
                            value={currentStudyProgramInfo.studyCycles ? getLookupName(currentStudyProgramInfo.studyCycles[0]) : ''}
                        />
                        <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.studyType" />}
                            keyName="studyType"
                            value={currentStudyProgramInfo.studyType}
                        />
                        <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.semester" />}
                            keyName="currentSemester"
                            value={
                                (function () {
                                    const gradInfo = currentStudyProgramInfo.gradStudentAcademicYear;
                                    const gradYear = gradInfo && gradInfo.name ? gradInfo.name : ''; // npr. "2012/2013"
                                    const sem = currentStudyProgramInfo.currentSemester || ''; // npr. "peti (2015/2016)"

                                    // izvuci godinu iz semestra ako postoji
                                    const match = sem.match(/\((\d{4})\/(\d{4})\)/);
                                    const semStartYear = match ? parseInt(match[1], 10) : 0;

                                    const gradStartYear = gradYear ? parseInt(gradYear.split('/')[0], 10) : 0;

                                    if (gradStartYear > semStartYear) {
                                        return <FormattedMessage id="student.graduateInternship" />;
                                    }

                                    return currentStudyProgramInfo.enrollmentCount
                                        ? <FormattedMessage id="student.semesterEnrollmentCount" values={{ semester: sem, count: currentStudyProgramInfo.enrollmentCount }} />
                                        : <FormattedMessage id="student.notEnrolled" />;
                                }())
                            }
                        />
                        <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="studentDocuments.status" />}
                            keyName="status"
                            value={currentStudyProgramInfo.studentStatus}
                        />
                        {(this.props.currentEducation && currentStudyProgramInfo.droppedOutDate !== null) &&
                            <SimpleTwoColumnTableRow
                                name={<FormattedMessage id="common.dateOfAbandonment" />}
                                keyName="dateOfAbandonment"
                                value={
                                    this.state.showEditDroppedOutDateForm ?
                                        <Form size="mini">
                                            <Form.Group widths="equal">
                                                <DateTimePicker
                                                    name="droppedOutDate"
                                                    format="D. M. YYYY."
                                                    time={false}
                                                    placeholder="Izaberite datum"
                                                    value={this.state.droppedOutDate ? new Date(this.state.droppedOutDate) : null}
                                                    onChange={(value) =>
                                                        this.handleInputChange(null, { name: 'droppedOutDate', value })
                                                    }
                                                    style={{ width: '100%' }}
                                                />
                                                <Button
                                                    basic="true"
                                                    color="blue"
                                                    size="mini"
                                                    floated="right"
                                                    onClick={() => {
                                                        this.saveDroppedOutDate();
                                                        this.setState({ showEditDroppedOutDateForm: false });
                                                    }}
                                                >
                                                    Sačuvaj
                                                </Button>
                                                <Button
                                                    basic="true"
                                                    size="mini"
                                                    floated="right"
                                                    onClick={() => {
                                                        this.setState({ showEditDroppedOutDateForm: false });
                                                    }}
                                                >
                                                    Odustani
                                                </Button>
                                            </Form.Group>
                                        </Form>
                                        : <Fragment>
                                            <Grid columns={2}>
                                                <Grid.Column
                                                    width={14}
                                                    verticalAlign="middle"
                                                > {moment(currentStudyProgramInfo.droppedOutDate)
                                                        .format('D. M. YYYY.')} </Grid.Column>
                                                {(!this.props.limitation || !this.props.locked) &&
                                                    <Grid.Column width={2} verticalAlign="middle">
                                                        {isAdmin && <Popup
                                                            size="tiny"
                                                            trigger={
                                                                <Button
                                                                    basic="true"
                                                                    circular
                                                                    floated="right"
                                                                    color="green"
                                                                    icon="pencil"
                                                                    size="mini"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            droppedOutDate: currentStudyProgramInfo.droppedOutDate,
                                                                            showEditDroppedOutDateForm: true
                                                                        });
                                                                    }}
                                                                />}
                                                            content="Izmijeni"
                                                            hideOnScroll
                                                            position="top center"
                                                        />}
                                                    </Grid.Column>}
                                            </Grid>
                                        </Fragment>
                                }
                            />
                        }

                        {(localStorage.getItem('activeRole').substr(0, 10) === 'Studentska' || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator') && <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.titleGender" />}
                            keyName="titleGender"
                            value={
                                <Fragment>

                                    {!this.state.showEditTitleGenderForm ?
                                        <Grid columns={2}>
                                            <Grid.Column width={14} verticalAlign="middle" > {currentStudyProgramInfo.genderForTitle ? currentStudyProgramInfo.genderForTitle.name : ''} </Grid.Column>
                                            {(!this.props.limitation || !this.props.locked) && <Grid.Column width={2} verticalAlign="middle" >
                                                <Popup
                                                    size="tiny"
                                                    trigger={<Button
                                                        basic="true"
                                                        circular
                                                        floated="right"
                                                        color="green"
                                                        icon="pencil"
                                                        size="mini"
                                                        onClick={() => {
                                                            this.setState({ showEditTitleGenderForm: true });
                                                        }}
                                                    />}
                                                    content="Izmijeni"
                                                    hideOnScroll
                                                    position="top center"
                                                />
                                            </Grid.Column>}
                                        </Grid>

                                        :
                                        <Form size="mini">
                                            <Form.Group widths="equal">
                                                <Form.Field>
                                                    <Form.Dropdown
                                                        placeholder="Odaberite rod"
                                                        options={this.state.genders}
                                                        onChange={this.handleInputChange}
                                                        name="titleGender"
                                                        value={this.state.titleGender ? this.state.titleGender : this.props.currentStudyProgramInfo.genderForTitle ? this.props.currentStudyProgramInfo.genderForTitle.id : null}
                                                        search
                                                        fluid
                                                        selection
                                                    />
                                                </Form.Field>
                                                <Button
                                                    basic="true"
                                                    color="blue"
                                                    size="mini"
                                                    floated="right"
                                                    onClick={() => {
                                                        this.saveTitleGender();
                                                        this.setState({ showEditTitleGenderForm: false });
                                                    }}
                                                >
                                                    Sačuvaj
                                                </Button>
                                                <Button
                                                    basic="true"
                                                    size="mini"
                                                    floated="right"
                                                    onClick={() => {
                                                        this.setState({ showEditTitleGenderForm: false });
                                                    }}
                                                >
                                                    Odustani
                                                </Button>
                                            </Form.Group>
                                        </Form>
                                    }
                                </Fragment>}
                        />}
                        {(localStorage.getItem('activeRole').substr(0, 10) === 'Studentska' || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator') && <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.comment" />}
                            keyName="comment"
                            value={
                                <Fragment>

                                    {!this.state.showEditForm ?
                                        <Grid columns={2}>
                                            <Grid.Column width={14} verticalAlign="middle" > {currentStudyProgramInfo.sspComment} </Grid.Column>
                                            {(((localStorage.getItem('activeRole').substr(0, 10) === 'Studentska') && (!this.props.limitation || !this.props.locked)) || (localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator')) && <Grid.Column width={2} verticalAlign="middle" >
                                                <Popup
                                                    size="tiny"
                                                    trigger={<Button
                                                        basic="true"
                                                        circular
                                                        floated="right"
                                                        color="green"
                                                        icon="pencil"
                                                        size="mini"
                                                        onClick={() => {
                                                            this.setState({ showEditForm: true });
                                                        }}
                                                    />}
                                                    content="Dodaj napomenu"
                                                    hideOnScroll
                                                    position="top center"
                                                />
                                            </Grid.Column>}
                                        </Grid>

                                        :
                                        <Form size="mini">
                                            <Form.Group widths="equal">
                                                <Form.Field width="2">
                                                    <input
                                                        defaultValue={currentStudyProgramInfo.sspComment}
                                                        value={this.state.comment}
                                                        onChange={(e) => this.setState({ comment: e.target.value })}
                                                        name="comment"
                                                        placeholder="Unesite napomenu"

                                                    />
                                                </Form.Field>
                                                <Button
                                                    basic="true"
                                                    color="blue"
                                                    size="mini"
                                                    floated="right"
                                                    onClick={() => {
                                                        this.saveComment();
                                                        this.setState({ showEditForm: false });
                                                    }}
                                                >
                                                    Sačuvaj
                                                </Button>
                                                <Button
                                                    basic="true"
                                                    size="mini"
                                                    floated="right"
                                                    onClick={() => {
                                                        this.setState({ showEditForm: false });
                                                    }}
                                                >
                                                    Odustani
                                                </Button>
                                            </Form.Group>
                                        </Form>
                                    }
                                </Fragment>}
                        />}

                        {(localStorage.getItem('activeRole').startsWith('Studentska') || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole').startsWith('Student:')) && <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.debit" />}
                            keyName="debit"
                            value={
                                <Fragment>

                                    {!this.state.showEditDebitForm ?
                                        <Grid columns={2}>
                                            <Grid.Column width={14} verticalAlign="middle" > {currentStudyProgramInfo.sspDebit} </Grid.Column>
                                            {(((localStorage.getItem('activeRole').substr(0, 10) === 'Studentska') && (!this.props.limitation || !this.props.locked)) || (localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator')) && <Grid.Column width={2} verticalAlign="middle" >
                                                <Popup
                                                    size="tiny"
                                                    trigger={<Button
                                                        basic="true"
                                                        circular
                                                        floated="right"
                                                        color="green"
                                                        icon="pencil"
                                                        size="mini"
                                                        onClick={() => {
                                                            this.setState({ showEditDebitForm: true });
                                                        }}
                                                    />}
                                                    content="Dodaj dugovanje"
                                                    hideOnScroll
                                                    position="top center"
                                                />
                                            </Grid.Column>}
                                        </Grid>

                                        :
                                        <Form size="mini">
                                            <Form.Group widths="equal">
                                                <Form.Field width="2">
                                                    <input
                                                        defaultValue={currentStudyProgramInfo.sspDebit}
                                                        value={this.state.debit}
                                                        onChange={(e) => this.setState({ debit: e.target.value })}
                                                        name="debit"
                                                        placeholder="Unesite dugovanje"

                                                    />
                                                </Form.Field>
                                                <Button
                                                    basic="true"
                                                    color="blue"
                                                    size="mini"
                                                    floated="right"
                                                    onClick={() => {
                                                        this.saveDebit();
                                                        this.setState({ showEditDebitForm: false });
                                                    }}
                                                >
                                                    Sačuvaj
                                                </Button>
                                                <Button
                                                    basic="true"
                                                    size="mini"
                                                    floated="right"
                                                    onClick={() => {
                                                        this.setState({ showEditDebitForm: false });
                                                    }}
                                                >
                                                    Odustani
                                                </Button>
                                            </Form.Group>
                                        </Form>
                                    }
                                </Fragment>}
                        />}
                    </Table.Body>
                </Table>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentPersonalInfo/CurrentStudyTable.js